// Bootstrap

import "bootstrap/js/dist/base-component";
import "bootstrap/js/dist/alert";
import "bootstrap/js/dist/button";
import "bootstrap/js/dist/carousel";
import "bootstrap/js/dist/collapse";
import "bootstrap/js/dist/dropdown";
import "bootstrap/js/dist/modal";
import "bootstrap/js/dist/offcanvas";
import "bootstrap/js/dist/popover";
import "bootstrap/js/dist/scrollspy";
import "bootstrap/js/dist/tab";
import "bootstrap/js/dist/toast";
import "bootstrap/js/dist/tooltip";

// Initialize tooltips and tabs
import { Tooltip, Tab } from 'bootstrap';

// Make Bootstrap available globally for inline scripts
window.bootstrap = { Tooltip, Tab };

var tooltipTriggerList = [].slice.call(
	document.querySelectorAll('[data-bs-toggle="tooltip"]')
);
var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
	return new Tooltip(tooltipTriggerEl);
});

// Initialize tabs when DOM is loaded
document.addEventListener('DOMContentLoaded', function() {
	console.log('Bootstrap Tab available:', typeof Tab); // Debug log
	console.log('Bootstrap on window:', window.bootstrap); // Debug log

	var tabTriggerList = [].slice.call(
		document.querySelectorAll('[data-bs-toggle="tab"]')
	);
	console.log('Found tabs:', tabTriggerList.length); // Debug log

	if (tabTriggerList.length > 0) {
		tabTriggerList.forEach(function (tabTriggerEl) {
			console.log('Initializing tab:', tabTriggerEl.id); // Debug log
			try {
				var tab = new Tab(tabTriggerEl);
				console.log('Tab initialized successfully:', tab);
			} catch (error) {
				console.error('Error initializing tab:', error);
			}
		});
	} else {
		console.log('No tabs found with data-bs-toggle="tab"');
	}
});

// var popoverTriggerList = [].slice.call(
// 	document.querySelectorAll('[data-bs-toggle="popover"]')
// );
// var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
// 	return new bootstrap.Popover(popoverTriggerEl);
// });

//NDA acceptance
$(".nda-checkbox input").attr("disabled", true);
$(".nda-checkbox .gfield_checkbox").addClass("disabled");
$(".nda-text").scroll(function(e) {
	if ($(this).scrollTop() + $(this).innerHeight() >= $(this)[0].scrollHeight) {
		$(".nda-checkbox input").removeAttr("disabled");
		$(".nda-checkbox .gfield_checkbox").removeClass("disabled");
	}
});

$(function() {
	$(".nda-checkbox input").click(function() {
		if (
			$(this).prop("disabled") &&
			$(".nda-text").scrollTop() + $(".nda-text").innerHeight() <
				$(".nda-text")[0].scrollHeight
		) {
			// if ($('.nda-text').scrollTop() + $('.nda-text').innerHeight() < $('.nda-text')[0].scrollHeight) {
			$(this).popover({
				container: ".nda-checkbox",
				placement: "bottom",
				content: "Read the NDA and scroll to the bottom to enable"
			});
		}
	});
});

// Login Form Placeholders
$('#user_login').attr('placeholder', 'USERNAME');
// $('#user_email').attr('placeholder', 'User Email');
$('#user_pass').attr('placeholder', 'PASSWORD');

// Custom
import initNavbarScroll from './navbarScroll';
import initFancybox from './fancybox';
import initGsap from './gsap';
import initSwiper from './swiper';

// Initialize Functionality
initFancybox();
initNavbarScroll();
initGsap();
initSwiper();

// ── Mobile drawer nav ─────────────────────────────────────────────────────────
(function () {
	var toggler = document.getElementById('mobileNavToggler');
	var drawer  = document.getElementById('mobileNavDrawer');
	var overlay = document.getElementById('mobileNavOverlay');

	if (!toggler || !drawer) return;

	function isMobile() {
		return window.innerWidth < 768;
	}

	function openDrawer() {
		drawer.classList.add('is-open');
		drawer.setAttribute('aria-hidden', 'false');
		if (overlay) overlay.classList.add('is-open');
		toggler.classList.add('is-open');
		toggler.setAttribute('aria-expanded', 'true');
		document.body.style.overflow = 'hidden';
	}

	function closeDrawer() {
		drawer.classList.remove('is-open');
		drawer.setAttribute('aria-hidden', 'true');
		if (overlay) overlay.classList.remove('is-open');
		toggler.classList.remove('is-open');
		toggler.setAttribute('aria-expanded', 'false');
		document.body.style.overflow = '';

		// Reset panels to root after animation finishes
		setTimeout(function () {
			var root = document.getElementById('mp-root');
			drawer.querySelectorAll('.mobile-panel').forEach(function (p) {
				p.classList.remove('is-active', 'is-behind');
			});
			if (root) root.classList.add('is-active');
		}, 380);
	}

	toggler.addEventListener('click', function (e) {
		if (!isMobile()) return;
		e.preventDefault();
		drawer.classList.contains('is-open') ? closeDrawer() : openDrawer();
	});

	if (overlay) {
		overlay.addEventListener('click', closeDrawer);
	}

	// Panel navigation
	drawer.addEventListener('click', function (e) {
		var goBtn   = e.target.closest('.mp-go');
		var backBtn = e.target.closest('.mp-back');

		if (goBtn) {
			var targetId    = goBtn.dataset.target;
			var targetPanel = document.getElementById(targetId);
			var current     = drawer.querySelector('.mobile-panel.is-active');
			if (targetPanel && current) {
				current.classList.remove('is-active');
				current.classList.add('is-behind');
				targetPanel.classList.add('is-active');
			}
		}

		if (backBtn) {
			var current     = e.target.closest('.mobile-panel');
			var parentId    = current ? current.dataset.parent : null;
			var parentPanel = parentId ? document.getElementById(parentId) : null;
			if (current && parentPanel) {
				current.classList.remove('is-active');
				parentPanel.classList.remove('is-behind');
				parentPanel.classList.add('is-active');
			}
		}
	});

	// Close on resize to desktop
	window.addEventListener('resize', function () {
		if (!isMobile() && drawer.classList.contains('is-open')) {
			closeDrawer();
		}
	});
})();
// ─────────────────────────────────────────────────────────────────────────────
